<template>
	<div id="data-list-list-view" class="-ml-4 -mr-4 flex-grow">
		<div class="mx-4 flex items-center">
			<span class="mr-3">Progress: </span>
			<vs-progress :percent="taskProgressPercent" color="primary" />
			<span class="ml-3">{{ roundedTaskProgressPercent }}%</span>
		</div>
		<vs-table ref="table" pagination :max-items="50" :data="results">
			<template slot="thead">
				<vs-th></vs-th>
				<vs-th>Task</vs-th>
				<vs-th>Customer Status</vs-th>
				<!-- <vs-th>Type</vs-th> -->
				<vs-th>Urgency</vs-th>
				<!-- <vs-th>Status</vs-th> -->
				<vs-th class="pr-0">
					<div class="w-full flex flex-nowrap items-center">
						<span style="text-transform: uppercase">Actions</span>
						<!-- <vs-button
							color="primary"
							class="px-3 ml-auto whitespace-nowrap"
							type="flat"
							icon-pack="feather"
							v-on:click.stop="bulkProcessTasks()"
							>Auto-Process-Actions</vs-button
						> -->

						<vs-dropdown class="px-3 ml-auto whitespace-nowrap">
							<a class="a-icon" href="#">
								Action for selected
								<vs-icon class="" icon="expand_more"></vs-icon>
							</a>
							<vs-dropdown-menu class="whitespace-nowrap">
								<vs-dropdown-item>Delete selected</vs-dropdown-item>
								<vs-dropdown-item>Pause selected</vs-dropdown-item>
								<vs-dropdown-item v-on:click.stop="bulkProcessTasks()">
									Do all selected
								</vs-dropdown-item>
							</vs-dropdown-menu>
						</vs-dropdown>
					</div>
				</vs-th>
			</template>

			<template slot-scope="{ data }">
				<tbody>
					<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
						<vs-td>
							<feather-icon
								v-if="tr.status == 'done'"
								icon="CheckIcon"
								class="p-3 ml-2 inline-flex rounded-full"
								:class="[`text-green`]"
								:style="{ background: '#00bb6a19' }"
							></feather-icon>
							<feather-icon
								v-else
								:icon="tr.icon ? tr.icon : 'CircleIcon'"
								class="p-3 ml-2 inline-flex rounded-full"
								:class="[`text-white`]"
								:style="{ background: `rgba(var(--vs-primary))` }"
							></feather-icon>
						</vs-td>

						<vs-td>
							<h4 class="mb-2">{{ tr.title }}</h4>
							<p class="whitespace-nowrap" :class="'text-' + tr.status" v-html="tr.description"></p>
						</vs-td>
						<vs-td>

							<div class="flex items-center ">
								<div style="min-width: 75px" class="flex mr-3">
									<vs-chip color="rgba(0, 0, 0, 0.1)" class="flex-grow text-dark" v-if="tr.customer_hotness == 'BOOKED'">{{tr.customer_hotness}}</vs-chip>
									<vs-chip color="primary" class="flex-grow" v-if="tr.customer_hotness == 'HOT'">{{tr.customer_hotness}}</vs-chip>
									<vs-chip color="rgba(var(--vs-primary),0.1)" class="text-primary flex-grow" v-if="tr.customer_hotness == 'WARM'">{{tr.customer_hotness}}</vs-chip>
									<vs-chip color="rgba(0, 0, 0, 0.1)" class="text-dark flex-grow" v-if="tr.customer_hotness == 'COLD'">{{tr.customer_hotness}}</vs-chip>
								</div>
								<div>
									{{tr.customer_status}}
								</div>
							</div>

						</vs-td>
						<!-- <vs-td> {{ tr.type }} </vs-td> -->
						<vs-td> {{ tr.urgency }} </vs-td>
						<!-- <vs-td> {{ tr.status }} </vs-td> -->
						<vs-td>
							<div class="w-full flex flex-nowrap items-center">
								<vs-button
									color="primary"
									class="px-3 whitespace-nowrap"
									type="flat"
									icon-pack="feather"
									icon="icon-play"
									v-if="tr.status != 'done' && tr.actionType !='refare'"
									v-on:click.stop="markDone(tr, indextr)"
									>{{ tr.actionLabel }}</vs-button
								>

								<vs-button
									color="primary"
									class="px-3"
									type="flat"
									icon-pack="feather"
									icon="icon-play"
									v-if="tr.status != 'done' "
									v-on:click.stop="dirtyToggleModal(indextr)"
									>{{tr.actionType !='refare' ? 'Preview' : tr.actionLabel }}</vs-button
								>

								<component
									v-bind:is="tr.actionComponent"
									:result="tr"
									v-if="tr.actionComponent && activeModal[indextr]"
									v-on:accept="markDone(tr, indextr)"
								/>

								<div class="ml-auto flex flex-nowrap">
									<vs-button
										v-if="tr.urgency != 'high' && tr.status != 'done'"
										size="large"
										color="#b4b4b4"
										type="flat"
										icon-pack="feather"
										icon="icon-pause"
									></vs-button>
									<vs-button
										color="#b4b4b4"
										type="flat"
										size="large"
										icon-pack="feather"
										icon="icon-trash"
									></vs-button>
								</div>
								<div class=" ">
									<div
										class="con-vs-checkbox mx-0 my-2 vs-checkbox-primary fake-checkbox vs-checkbox-default"
										v-bind:class="{ checked: selected[indextr] }"
										v-on:click.stop.prevent="selected[indextr] = !selected[indextr]"
									>
										<span
											class="checkbox_x vs-checkbox"
											style="border: 2px solid rgb(180, 180, 180)"
										>
											<span class="vs-checkbox--check">
												<i
													class="vs-icon notranslate icon-scale vs-checkbox--icon material-icons null"
													>check</i
												>
											</span>
										</span>
									</div>
								</div>
							</div>
						</vs-td>
						<template slot="expand">
							<cat-task-results-details :result="tr" />
						</template>
					</vs-tr>
				</tbody>
			</template>
		</vs-table>
	</div>
</template>

<script>
import CatTaskResultsDetails from "@/components/cat/TaskResultsDetails.vue";
import CatTaskResultsRefare from "@/components/cat/TaskResultsRefare.vue";
import CatTaskResultsPriceDropMessage from "@/components/cat/TaskResultsPriceDropMessage.vue";
import CatTaskResultsReActivate from "@/components/cat/TaskResultsReActivate.vue";
import CatTaskResultsPersonalizedOffer from "@/components/cat/TaskResultsPersonalizedOffer.vue";
import Vue from "vue";
export default {
	components: {
		CatTaskResultsDetails,
		CatTaskResultsRefare,
		CatTaskResultsPriceDropMessage,
		CatTaskResultsReActivate,
		CatTaskResultsPersonalizedOffer,
	},
	props: {
		results: {
			type: Array,
			required: true,
		},
	},
	data() {
		let activeModal = {};
		let selected = {};
		this.results.forEach(function (r, key) {
			activeModal[key] = false;
			selected[key] = false;
		});
		return {
			activeModal: Vue.observable(activeModal),
			selected: Vue.observable(selected),
		};
	},
	methods: {
		dirtyToggleModal(indextr) {
			this.activeModal[indextr] = false;
			this.$nextTick(function () {
				this.activeModal[indextr] = true;
			});
		},
		markDone(tr, indextr) {
			console.log("MARKDONE", tr, indextr);
			tr.status = "done";
			window.sampleTaskList[indextr].status = "done";
		},
    bulkProcessTasks() {
      let that = this;
      this.results = this.results.map(function(r, key) {
        if (that.selected[key]) {
          r.status = 'done';
          that.selected[key] = false;
        };
        return r;
      })
    }
	},
	computed: {
		taskProgressPercent() {
			return (
				(100 * this.results.filter((tr) => tr.status == "done").length) /
				this.results.length
			);
		},
		roundedTaskProgressPercent() {
			return Math.ceil(this.taskProgressPercent);
		},
	},
};
</script>

<style lang="scss">
#data-list-list-view .vs-con-table .vs-con-tbody {
	border-width: 0;
}

.con-vs-dialog .vs-dialog {
	max-width: 600px;
}
</style>
